import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@app/store';
import { SHOP_PAGE_TEXTS } from './constants';

interface ShopState {
  contentText: string;
  currentPath: keyof typeof SHOP_PAGE_TEXTS;
}

const initialState: ShopState = {
  contentText: SHOP_PAGE_TEXTS['/shop'],
  currentPath: '/shop'
};

export const shopSlice = createSlice({
  name: 'shop',
  initialState,
  reducers: {
    setShopPath: (state, action) => {
      const path = action.payload as keyof typeof SHOP_PAGE_TEXTS;
      state.currentPath = path;
      state.contentText = SHOP_PAGE_TEXTS[path];
    },
    setContentText: (state, action: PayloadAction<string>) => {
      state.contentText = action.payload;
    },
    clearContent: (state) => {
      state.contentText = '';
    }
  }
});

export const { setShopPath, setContentText, clearContent } = shopSlice.actions;
export const selectContentText = (state: RootState) => state.shop.contentText;

export default shopSlice.reducer;
